module.exports = __webpack_public_path__ + "static/media/warning.3b3980c8.svg";